import { Component, OnInit } from '@angular/core';
import { ListItem } from '@kaiser-software/chassis-core/src/app/plugins/abstract-plugins/list/list-item';

@Component({
    selector: 'address-relation-list-item',
    templateUrl: 'address-relation.list-item.html',
    styleUrls: ['address-relation.list-item.scss']
})

export class AddressRelationListItem implements OnInit {

    public item;

    constructor(public listItem: ListItem) {
    }

    ngOnInit() {
    }

    public remove($event) {
        this.listItem.openRemoveModal();

        $event.preventDefault();
        $event.stopPropagation();
    }
}


// WEBPACK FOOTER //
// ./libs/donna-core/src/app/addresses/plugins/address-relation/item/address-relation.list-item.ts